import { render, staticRenderFns } from "./consumption-record.vue?vue&type=template&id=1529a643"
import script from "./consumption-record.vue?vue&type=script&lang=js"
export * from "./consumption-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports